import { render, staticRenderFns } from "./FeesCard.vue?vue&type=template&id=45541d32&scoped=true&"
import script from "./FeesCard.vue?vue&type=script&lang=js&"
export * from "./FeesCard.vue?vue&type=script&lang=js&"
import style0 from "./FeesCard.vue?vue&type=style&index=0&id=45541d32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45541d32",
  null
  
)

export default component.exports